import config from "../config.js";
import {
    poorcatsnftcontract,
    modalText,
    transactionStatus,
    blocked
} from "../stores/global.js";

export async function checkNetwork (chainId) {
  let networkName;

  switch (chainId) {
    case 1:
      networkName = "Main";
      break;
    case 2:
      networkName = "Morden";
      break;
    case 3:
      networkName = "Ropsten";
      break;
    case 4:
      networkName = "Rinkeby";
      break;
    case 42:
      networkName = "Kovan";
      break;
    default:
      networkName = "Unknown";
  }

  console.log("Connected to " + networkName);
  
  //TODO: CHANGE TO MAIN ON DEPLOY
  return networkName == "Main"
};

export async function getContracts(web3, chainId) {
  // await checkNetwork(chainId);
  // console.log(await checkNetwork(chainId));

  let poorcatsnft = await new web3.eth.Contract(
    config.poorcatsnft.abi,
    config.poorcatsnft.address
  );

  await poorcatsnftcontract.set(poorcatsnft);
  };